export default "__VITE_ASSET__DRFNIpU2__"